import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/providers/emr-systems-supported/#webpage",
   "url": "https://www.futurefamilyai.com/providers/emr-systems-supported/",
   "name": "Supported EMR Systems & Integration Matrix | FutureFamilyAI",
   "description": "Request the current integration matrix, security documentation and interface specs. No EMR is listed as supported until verified live.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "EMR Integration",
     "item": "https://www.futurefamilyai.com/providers/emr-integration/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Supported EMR Systems",
     "item": "https://www.futurefamilyai.com/providers/emr-systems-supported/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Which EMRs does FutureFamilyAI support?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "See the current integration matrix; systems are listed as supported only after verification."
     }
    },
    {
     "@type": "Question",
     "name": "Is Epic supported?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Epic connectivity is confirmed per organization after verification."
     }
    },
    {
     "@type": "Question",
     "name": "What documentation is available?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Security documentation, interface specifications and deployment timelines."
     }
    },
    {
     "@type": "Question",
     "name": "How long does implementation take?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It depends on your EMR and approvals."
     }
    },
    {
     "@type": "Question",
     "name": "Is there an integration fee?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Discuss with our team during your demo."
     }
    },
    {
     "@type": "Question",
     "name": "Can we pilot without EMR integration?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function ProvidersEmrSystemsSupportedPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/providers/emr-integration">EMR Integration</Link>
              <span>›</span>
              <span>Supported EMR Systems</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI lists an EMR as supported only after a live
                integration has been verified.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Health IT &amp; practice administrators</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Patient-generated health data is health-related data
                      created, recorded or gathered by patients to help address
                      a health concern. (ONC / HealthIT.gov)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Verified-only listings · Clear documentation · Start
                      without waiting
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PROVIDER GUIDE</span>
            <h1>Supported EMR Systems — Verify Before You Implement</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI lists an EMR as supported only after a live
              integration has been verified. To evaluate fit, request the
              current integration matrix, security documentation, interface
              specifications and deployment timeline. Practices can begin today
              with structured summaries while integration is scoped. Each
              listing shows the interface type, status and the date it was last
              verified, so your team can plan with confidence. Request the
              integration matrix.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Practice administrator reviewing EMR integration requirements"
              >
                <figcaption>
                  <b>Photo slot</b> · Server-room-free, human image: practice
                  administrator at a laptop with a checklist on a clipboard
                  (unreadable), bright office.
                  <br />
                  <b>Alt:</b> Practice administrator reviewing EMR integration
                  requirements
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Patient-generated health data is health-related data
                    created, recorded or gathered by patients to help address a
                    health concern.
                    <cite>
                      Source:{" "}
                      <a href="https://www.healthit.gov/topic/scientific-initiatives/pcor/patient-generated-health-data-pghd">
                        ONC / HealthIT.gov
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Integration matrix (maintained by FutureFamilyAI)</h2>
                <ul>
                  <li>EMR / version</li>
                  <li>Interface type</li>
                  <li>Status: Verified live · In implementation · Planned</li>
                  <li>Last verified date</li>
                </ul>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Which EMRs does FutureFamilyAI support?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        See the current integration matrix; systems are listed
                        as supported only after verification.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is Epic supported?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Epic connectivity is confirmed per organization after
                        verification.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What documentation is available?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Security documentation, interface specifications and
                        deployment timelines.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How long does implementation take?</summary>
                    <div className="ffh-ans">
                      <p>It depends on your EMR and approvals.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Is there an integration fee?</summary>
                    <div className="ffh-ans">
                      <p>Discuss with our team during your demo.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we pilot without EMR integration?</summary>
                    <div className="ffh-ans">
                      <p>Yes.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/providers/emr-integration">EMR Integration →</Link>
                  <Link to="/providers">For Physicians →</Link>
                  <Link to="/providers/epic-integration-patient-generated-data">
                    Epic Patient-Generated Data →
                  </Link>
                  <Link to="/providers/physician-dashboard-pregnancy-monitoring">
                    Physician Dashboard →
                  </Link>
                  <Link to="/providers/how-to-recommend-future-family">
                    Recommend FutureFamilyAI →
                  </Link>
                  <Link to="/providers/clinical-protocol-acog-smfm">
                    Clinical Protocol →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">
                      Integration matrix (maintained by FutureFamilyAI)
                    </a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
